import React from "react";
import ArticalListBanner from "./ArticalListBanner";
import { Col, Container, Row } from "react-bootstrap";
import CategorisRecentPost from "./CategorisRecentPost";

const ArticalCategory = () => {
  return (
    <>
      <ArticalListBanner />
      <section className="articals_wrapper py-3 margin_bottomfooter ">
        <Container fluid>
          <Row className="mb-4 justify-content-center">
            <Col xl={12} lg={12}>
              <Row className="justify-content-center gx-xl-5">
                <Col className="col-lg-8 col-xl-8 col-xxl-9 ps-xl-0">
                  <div className="topics_tags">
                    <p className="fs-3 pb-3 mb-3 mt-2" style={{fontStyle: "italic"}}><b>Category :</b> Animals</p>
                  </div>
                </Col>
                <Col lg={3} xl={3} xxl={2} className="pe-xl-0 ">
                  <CategorisRecentPost />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ArticalCategory;
